import { InfoCircleOutlined} from "@ant-design/icons";
import { Tooltip } from "antd";

export const UserNameColumnHandler = ({data,viewUsersDetailsHandler}) => {
    const userData=data?.dataItem;
    return (
            <td>
                <span onClick={() => viewUsersDetailsHandler(true,userData)} className='text-link'>{userData?.userName}</span>
            </td>
    )
}
export const StatusColumnHandler = ({data,badge}) => {
    const state = data?.dataItem?.isActive === true ? "Active":"Inactive" 
    return (
        <td> <span className={`status-badge ${badge[state?.toLowerCase()] || "bg-green"}`}>{state}</span></td>
    )
}

export const PasswordInstructions=()=>{
        return<div className="flex items-center gap-1 absolute top-0 left-20 passwordInput-tooltip">
        <div className="mt-0.5">
        <Tooltip
            title={
                <div className="!text-start">
                  <p>Your password must contain:</p>
                  <ul className="ms-1.5 !text-primaryColor text-xs">
                    <li><span className="icon tick-icon"></span>At least 8 characters</li>
                    <li><span className="icon tick-icon"></span>At least one lowercase (a-z).</li>
                    <li><span className="icon tick-icon"></span>At least one uppercase (A-Z).</li>
                    <li><span className="icon tick-icon"></span>At least one number (0-9).</li>
                    <li><span className="icon tick-icon"></span>At least one special symbol (e.g., !, @, #, $).</li>
                  </ul>
                </div>
              }
        >
            <span className="!text-whiteText">
                <InfoCircleOutlined />
            </span>
        </Tooltip>
        </div>
    </div>
    }